/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const initPostcardType = function() {
  const $postcard_type = $('#postcard_type');

  $postcard_type.change(function() {
    const $wrappers = $('.postcards form').find('.random, .validation');
    $wrappers.find('select,input,textarea').prop('disabled', true);
    $wrappers.hide();

    const type = $postcard_type.val();
    if (type) {
      $('.' + type).find('select, input, textarea').prop('disabled', false);
      $('.' + type).show();
    }
  });

  $postcard_type.change();
};

const updateAddressCount = function(event) {
  let addressCount;
  const userCount = parseInt($('input[name="postcard[target_user_count]"]').val());
  const rate = parseFloat($('input[name="postcard[conversion_rate]"]').val());
  if (userCount && rate) {
    addressCount = Math.round(userCount / rate);
  } else {
    addressCount = '';
  }
  $('input[name="postcard[address_count]"]').val(addressCount);
};


const initPostcardCount = function() {
  $('input[name="postcard[target_user_count]"]').on('change', event => updateAddressCount(event));
  $('input[name="postcard[conversion_rate]"]').on('change', event => updateAddressCount(event));
};

const onSelectedPostcardTemplate = function(selected_template) {
  if (selected_template) {
    const $selected_postcard_template = $('#selected_postcard_template');
    const previous_selected_template = $selected_postcard_template.val();
    if (previous_selected_template !== selected_template) {
      const $previous_container = $('.' + previous_selected_template);
      $previous_container.find('select,input,textarea').prop('disabled', true);
      $previous_container.hide();

      const $new_cointainer = $('.' + selected_template);
      $new_cointainer.find('select,input,textarea').prop('disabled', false);
      $new_cointainer.show();
      $selected_postcard_template.val(selected_template);
    } else {
      const $container = $('.' + selected_template);
      $container.find('select,input,textarea').prop('disabled', false);
      $container.show();
    }
  } else {
    $('.postcard-template-container').hide();
  }
};

const initPostcardTemplate = function() {
  onSelectedPostcardTemplate($('#selected_postcard_template').val());
  $('#postcard_template_id').on('change', function() {
    onSelectedPostcardTemplate(this.value);
  });
};

root.initPostcard = function() {
  initPostcardType();
  initPostcardCount();
  initPostcardTemplate();
};

/*
$(function() {
  if ($('.postcards form').length) {
    initPostcard();
  }

  const $slow_images = $('.slow-images');
  if ($slow_images.length) {
    return $slow_images.imageReloader();
  }
});
*/

function initPostcardsOnLoad() {
  if ($('.postcards form').length) {
    initPostcard();
  }

  const $slow_images = $('.slow-images');
  if ($slow_images.length) {
    return $slow_images.imageReloader();
  }
}

$(initPostcardsOnLoad);
document.addEventListener('turbo:load', initPostcardsOnLoad);
